import type { ThunkOn, Thunk } from 'easy-peasy';
import { thunk, thunkOn } from 'easy-peasy';
import type { StoreModel } from '..';
import { message, notification } from 'antd';
import buildDetailInfoLink from './util';
import type { ReactNode } from 'react';

declare type NoticeType = 'info' | 'success' | 'error' | 'warning' | 'loading';

export declare interface Message {
  noticeType: NoticeType;
  content: string | ReactNode;
  duration?: number;
  icon?: string;
  link?: string;
}

export interface MessagesModel {
  dispatchMessage: Thunk<MessagesModel, Message>;
  dispatchErrorNotification: Thunk<MessagesModel, Message>;
  onThrowApplicationError: ThunkOn<MessagesModel, void, StoreModel>;
}

export const messagesModel: MessagesModel = {
  dispatchErrorNotification: thunk((state, payload) => {
    const { icon } = payload;
    notification.error({
      message: 'An Error Occured',
      description: buildDetailInfoLink(payload),
      icon,
      duration: payload.duration,
    });
  }),
  dispatchMessage: thunk((state, payload) => {
    const { content, noticeType, duration = 8, icon } = payload;
    message.open({ content, type: noticeType, duration, icon });
  }),
  onThrowApplicationError: thunkOn(
    (actions, storeActions) => storeActions.errors.throwApplicationError,
    (actions, payload) => {
      if (!payload.payload.hasOwnProperty('asNotification') || payload.payload.asNotification) {
        const duration = payload.payload.hasOwnProperty('duration') ? (payload.payload as any).duration : 4;
        const link = payload.payload.hasOwnProperty('link') ? (payload.payload as any).link : undefined;
        actions.dispatchErrorNotification({
          content: payload.payload.message,
          noticeType: 'error',
          duration,
          link,
        });
      }
    },
  ),
};
